function ArrowSelectorTool() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="#C1C7CE"
      viewBox="0 0 24 24"
    >
      <path
        fill="#C1C7CE"
        d="M7.589 14.102l2.306-3.219h4.839L7.589 5.265v8.837zm7.31 6.764c-.339.16-.677.177-1.015.05a1.312 1.312 0 01-.748-.696L10 13.479l-2.26 3.147c-.272.383-.63.504-1.074.362-.443-.142-.665-.445-.665-.91V3.97c0-.4.18-.688.54-.862.36-.173.7-.136 1.018.112l9.59 7.546c.365.28.47.634.316 1.064-.154.429-.46.643-.918.643h-4.102l3.1 6.631c.16.339.178.677.051 1.015a1.312 1.312 0 01-.697.748z"
      ></path>
    </svg>
  );
}

export default ArrowSelectorTool;
